module.exports = __webpack_public_path__ + "static/media/plane-Desktop.f5289425.png";